// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"b3a55c51","787":"574e323e"}[chunkId] + ".chunk.js";
};